export const SUBSIDY_BASE_URL = 'subsidy/'
export const SUBSIDY_USER_LOGIN_URL = 'login';
export const SUBSIDY_PRELOGIN_URL = 'prelogin';
export const SUBSIDY_CLIENT_DATA_URL = 'client-data';
export const SUBSIDY_CONFIRM_URL = 'confirm';
export const SUBSIDY_VOUCHER_URL = 'voucher';
export const SUBSIDY_SUBROGATION_LOGIN_URL = 'subrogation-login';
